import React from 'react';
import './courseCard.css'
import C2wcourseCardDateinfo from './courseCardDateinfo';
import C2wCourseCount from './count';
import { useNavigate } from 'react-router';

function C2wCourseCard ({ obj=null } ) {
  const navigate = useNavigate()
  const rendredCoursesCountsCards = obj?.topicArray?.map(( objCount, idx) => {
    return <C2wCourseCount obj={objCount} />
  })

   const generateSlug = (name) =>
  name?.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "");

  return (
    <div className='C2wCourseCard' onClick={() => {
        navigate(`/courses/${generateSlug(obj?.slug)}`);
    }}>
        <div className='c2w_image_holder'><img className='C2wCourseCard_thumnnail_img' src={`/assets/images/courses/${obj?.thumbnailImage}`} alt={obj?.thumbnailImage} />
        <div className='C2wCourseCard_feesdiv'>
            {`₹ ${obj?.fees}`}
            <div className='C2wCourseCard_line'></div> 
            <div className='C2wCourseCard_feesDivGST'>{`+ ${obj?.gst}% GST`}</div>   
        </div>
        </div>
        <div className='C2wCourseCard_hover_ctn'>
            <C2wcourseCardDateinfo title={obj?.admissionType} validity={obj?.validityType} />
            <div className='C2wCourseCard_hover_Count_ctn'>
                {rendredCoursesCountsCards}
            </div>  
        </div>
    </div>
  )
}

export default C2wCourseCard